import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { allCarrerasAction } from '../../../sistema/carreras/CarrerasAction';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allEntMonedasAction,
  deleteEntMonedasAction,
  setActivoEntMonedasAction,
} from '../EntMonedasAction';
import { PARAMS_ENT_CARRERAS } from '../EntMonedasReducer';

const ListadoEntMonedas = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const carrerasStore = Redux.useSelector((state) => state.carreras);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const entMonedasStore = Redux.useSelector((state) => state.entMonedas);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    const fetchData = async () => {
      if (carrerasStore.all && carrerasStore.all.length === 0) {
        await allCarrerasAction(dispatch, null);
      }
      const payload = {
        ...entMonedasStore.params,
        idEntidad: entidadesStore.activo.id,
      };
      dispatch({ type: PARAMS_ENT_CARRERAS, payload });
      if (entMonedasStore.all && entMonedasStore.all.length === 0) {
        await allEntMonedasAction(dispatch, payload);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleEditClick = async (id) => {
    const data = entMonedasStore.all.find((el) => el.id === id);
    await setActivoEntMonedasAction(dispatch, data);
    setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteEntMonedasAction(
      { dispatch, notify },
      entMonedasStore.activo.id,
      entMonedasStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.moneda.name,
      label: CONST.moneda.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value?.abrev}: {value?.nombre} ({value?.simbolo})
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.oficial.name,
      label: CONST.oficial.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? 'SI' : 'NO';
        },
      },
    },
    {
      name: CONST.tasa.name,
      label: CONST.tasa.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography variant="h6" fontWeight="bold" color="initial">
              {value}
            </Typography>
          );
        },
      },
    },
    {
      name: CONST.cambio.name,
      label: CONST.cambio.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? (
            <Typography variant="body1" color="initial">
              {value.abrev}: {value.nombre} ({value.simbolo})
            </Typography>
          ) : (
            '--'
          );
        },
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value?.nombre ?? '--'}
                size="small"
                color={value?.id === 1 ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  const data = entMonedasStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  await setActivoEntMonedasAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <LoadingWidget isLoading={entMonedasStore.loadingAll || loadingDelete} />
      <Grid item md={12}>
        <MUIDataTable
          title={'Listado'}
          data={entMonedasStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
      {entMonedasStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            {entMonedasStore.activo.moneda.nombre}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoEntMonedas;
